var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{attrs:{"id":"HOME"}},[(_vm.isNavigationFlatComputed)?_c('VNavigationCardsFlat'):_c('VNavigationCardsGrouped')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }